import React from 'react';
import clsx from 'clsx';

import './index.scss';

const PcSkillLevel = ({ value, id, name, onChange, checked, level, salary, skill }) => {

  const dir = require.context('assets/');
  const shoIcon = dir(`./icon_shyokyuu.png`);
  const chuIcon = dir(`./icon_tyuukyuu.png`);
  const jouIcon = dir(`./icon_joukyuu.png`);

  const DispImg = () => {
    switch (level) {
      case '初級': return (
        <span className="">
          <img className="rate" src={shoIcon} alt="" />
        </span>
      ); break;
      case '中級': return (
        <span className="">
          <img className="rate" src={chuIcon} alt="" />
        </span>
      ); break;
      case '上級': return (
        <span className="">
          <img className="rate" src={jouIcon} alt="" />
        </span>
      ); break;
      default: break;
    }
  };

  const DispSkill = () => {
    return (
      <span>
        {skill.map(data => (
          <span className="">
            {data}
            <br />
          </span>
        ))}
      </span>
    );
  };

  return (
    <div className={clsx('PcSkillLevel', { checked })}>
      <label htmlFor={id}>
        <div className='radio-input-wrapper'>
          <span className="radioArea">
            <input
              type='radio'
              id={id}
              value={value}
              onChange={onChange}
              checked={checked}
              name={name}
            />
          </span>

          <span className="levelArea">
            <span className="level">
              {level}
            </span>
            <span className="">
              <DispImg />
            </span>
          </span>

          <span className="contentArea">
            <span className="salaryArea">
              <span className="tagArea">
                <label className="tag">請求金額目安（1時間）</label>
              </span>
              <span className="">
                {salary}
              </span>
            </span>

            <span className="skillArea">
              <span className="tagArea">
                <label className="tag">OAスキル</label>
              </span>
              <span className="tagDetail">
                <DispSkill />
              </span>
            </span>
          </span>
        </div>
      </label>
    </div>
  );
};

export default PcSkillLevel;